<template>
  <div class="hy-people">
    <!--嘉宾详情-->
    <div class="people_info">
         <div class="top">
              <div class="imgbox">
                <img :src="people.head_img" alt="">
              </div>
              <div class="textbox">
                <h5 class="hy_name">{{people.name}}</h5>
                <p class="hy_ssapid">SSAPID : {{people.ssapid}}</p>
                <p class="hy_type">{{people.domain}}</p>
                <p class="hy_jigou">{{people.company}}</p>
              </div>
         </div>
         <div class="infobox">
           <h3>作者简介</h3>
           <div class="infotext"  v-html="people.description"></div>
         </div>
    </div>
    <!--底部按钮-->
      <footerFixed />

  </div>
</template>


<script>
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        people: {
        },
        loading: false,
        finished: false,
        footerNav: false,
      };
    },
    created() {
      var _this = this;
      _this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      setTimeout(function(){
        _this.people = JSON.parse(localStorage.getItem('guest'));
      },1000);
      var wxShareInfo ={
        title:_this.people.name,
        info:_this.people.company,
        shareurl:window.location.href,
        img:_this.people.head_img
      };
      _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:wxShareInfo});
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        if (path == '') {
          return false;
        }
        this.$router.push(path)
      },
      //搜索方法
      onSearch(val) {
        this.$toast(val);
      },
      addList() {
        this.$get('/ac1/conference/index', {
          page: 1,
          pagesize: 10
        }).then(res => {

        })
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
    },
    mounted() {
      this.addList();
    }
  }
</script>
<style lang="less" scoped>

</style>
